import { render, staticRenderFns } from "./post_filter.vue?vue&type=template&id=9eebbefc&"
import script from "./post_filter.vue?vue&type=script&lang=js&"
export * from "./post_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../themes/chop-child/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/proservdemo25/public_html/wp-content/themes/chop-child/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9eebbefc')) {
      api.createRecord('9eebbefc', component.options)
    } else {
      api.reload('9eebbefc', component.options)
    }
    module.hot.accept("./post_filter.vue?vue&type=template&id=9eebbefc&", function () {
      api.rerender('9eebbefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "plugins/MtcPostFilter/assets/components/post_filter.vue"
export default component.exports